import { useMutation, useQuery } from '@tanstack/react-query';

import { featureFlags } from 'services/authService';

import { notifyError, notifySuccess } from 'utils/notifyUtils';

export const useFeatureFlagsQuery = (groupLocator) =>
  useQuery(['feature-flags', groupLocator], () =>
    featureFlags.get(groupLocator),
  );

export const useUpdateFeatureFlagsMutation = (groupLocator, callBack) =>
  useMutation((data) => featureFlags.update(groupLocator, data), {
    onError: (err) => notifyError('Error Updating Feature Flags', err.message),
    onSuccess: () => {
      notifySuccess(
        'Feature Flags Updated',
        'Feature flags updated successfully',
      );
      callBack();
    },
  });
